// src/models/IDDocumentModel.ts
import { createIDDocument } from '@/factories/idDocumentFactory'
import type { IDDocument, IDDocumentType } from '@/types/IDDocument'

export const IDDocumentModel = {
  create: createIDDocument,

  normalize(data: unknown): IDDocument {
    const input = data as Partial<IDDocument> & Record<string, unknown>
    const id = (input.id as string | undefined) || undefined
    const personId = (input.personId as string | undefined) || ''
    const type = (input.type as IDDocumentType | undefined) || 'driver_license'
    const idNumber = (input.idNumber as string | undefined) || undefined
    const issuer = (input.issuer as string | undefined) || undefined
    const issueRaw = input.issueDate as string | number | Date | undefined
    const expRaw = input.expirationDate as string | number | Date | undefined
    const frontImageUrl = (input.frontImageUrl as string | undefined) || undefined
    const backImageUrl = (input.backImageUrl as string | undefined) || undefined
    const barcodeHash = (input.barcodeHash as string | undefined) || undefined
    const rawBarcodeData = (input.rawBarcodeData as string | undefined) || undefined
    const verified = Boolean(input.verified)
    const notes = (input.notes as string | undefined) || undefined
    const createdRaw = input.createdAt as string | number | Date | undefined
    const updatedRaw = input.updatedAt as string | number | Date | undefined
    const isDeleted = Boolean(input.isDeleted)

    return {
      id,
      personId,
      type,
      idNumber,
      issuer,
      issueDate: issueRaw ? new Date(issueRaw) : undefined,
      expirationDate: expRaw ? new Date(expRaw) : undefined,
      frontImageUrl,
      backImageUrl,
      barcodeHash,
      rawBarcodeData,
      verified,
      notes,
      createdAt: createdRaw ? new Date(createdRaw) : new Date(),
      updatedAt: updatedRaw ? new Date(updatedRaw) : new Date(),
      isDeleted,
    }
  },

  isExpired(doc: IDDocument): boolean {
    if (!doc.expirationDate) return false
    return new Date(doc.expirationDate).getTime() < Date.now()
  },

  isNearExpiration(doc: IDDocument, days = 30): boolean {
    if (!doc.expirationDate) return false
    const ms = days * 24 * 60 * 60 * 1000
    const soon = Date.now() + ms
    return new Date(doc.expirationDate).getTime() <= soon && !IDDocumentModel.isExpired(doc)
  },

  hasPhoto(doc: IDDocument): boolean {
    return !!doc.frontImageUrl || !!doc.backImageUrl
  },
}
